import { ConsultationStatus } from '@/shared/api/transcriptor/transcriptorApi';

export const canReorderConsultation = (status?: ConsultationStatus): boolean =>
  status === 'succeeded' || status === 'failed';
